import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const MembershipBasicInfoComponent = ({ domains, handleInnerFormChange, selectedMembership, roles }: any) => (
        <>
    <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Name"
            labelField="Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Name'
              );
            }}
            type="text"
            value={selectedMembership?.Name}
        />
       
     <InputContainer
              label="Account Level"
              name="IsAccountLevel"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsAccountLevel'
                )
              }}
              type="checkbox"
              value={selectedMembership?.IsAccountLevel}
          />
      <InputContainer
              label="Associated Role"
              labelField="Name"
              list={roles}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AssociatedRoleId'
                )
              }}
              optionName='Choose AssociatedRole'
              type="select"
              value={selectedMembership?.AssociatedRoleId}
              valueField="Name"
          />
   <InputContainer
              label="Associated Domain"
              labelField="DomainName"
              list={domains}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AssociatedDomainId'
                )
              }}
              optionName='Choose AssociatedDomain'
              type="select"
              value={selectedMembership?.AssociatedDomainId}
              valueField="Id"
          />
        <InputContainer
              label="Membership Length"
              name="MembershipLengthId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipLengthId'
                )
              }}
              type="number"
              value={selectedMembership?.MembershipLengthId}
          />
       <InputContainer
              label="Membership Cycle Period"
              name="MembershipCycleId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipCycleId'
                )
              }}
             
              type="number"
              value={selectedMembership?.MembershipCycleId}
          />
           <InputContainer
            label="Price"
            labelField="Price"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Price'
              );
            }}
            type="number"
            value={selectedMembership?.Price}
        />
<div className='col-span-full'>
        <InputContainer
     label="Benefits" 
     onValueChange={( newValue: any) => {
       const benefitData: any = newValue.map((option: any) => option?.id || '')
       handleInnerFormChange(
        benefitData,
      'Benefits'
      
       );
     }}
     type="multiselectText"
     value={selectedMembership?.Benefits}
 />
      </div>
<div className='col-span-full'>
    <InputContainer
          
          label="Description"
          name="Description"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'Description'
             
            )
          }}
          type="text"
          value={selectedMembership?.Description}
      />
     </div></div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Information"
/>
        </>
)
export default MembershipBasicInfoComponent;
